//	Custom target ref: https://rangle.gitbook.io/redux-beacon/examples-and-recipes#how-to-create-your-own-target
import { createMiddleware } from 'redux-beacon'
import eventsMap from './eventsMap'
import addUserAnalytics from '../dataservices/addUserAnalytics'
import removeUndefined from '../utilities/Data/removeUndefined'

const trackPage = func => (action, prevState, nextState) => ({ type: 'page', ...func(action, prevState, nextState) })
const trackEvent = func => (action, prevState, nextState) => ({ type: 'event', ...func(action, prevState, nextState) })

//	Target gets an array of the result returned from page and event
const target = async (events) => {
	if (events && events.length > 0) {
		events.forEach(async event => addUserAnalytics({ event: removeUndefined(event) }))
	}
}

const kitfitAnalyticsMiddleware = createMiddleware(eventsMap(trackPage, trackEvent), target)

export default kitfitAnalyticsMiddleware



// WEBPACK FOOTER //
// ./src/analytics/kitfitAnalyticsMiddleware.js